/* eslint-env browser */

import 'vite/modulepreload-polyfill'
import FlyntComponent from './scripts/FlyntComponent'

/* -------------------------
   Lucide icons
   ------------------------- */
import { createIcons, icons } from 'lucide'

if (import.meta.env.DEV) {
  import('@vite/client')
}

import.meta.glob([
  '../Components/**',
  '../assets/**',
  '!**/*.js',
  '!**/*.scss',
  '!**/*.php',
  '!**/*.twig',
  '!**/screenshot.png',
  '!**/*.md'
])

window.customElements.define('flynt-component', FlyntComponent)

function initLucide (root = document) {
  const el = root && root.nodeType === 1 ? root : document

  const hasLucide = el === document
    ? document.querySelector('[data-lucide]')
    : el.querySelector('[data-lucide]')

  if (!hasLucide) return

  createIcons({ icons, attrs: { 'stroke-width': '2' } })
}

document.addEventListener('DOMContentLoaded', () => {
  initLucide(document)

  if ('MutationObserver' in window) {
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1) initLucide(node)
        }
      }
    })

    mo.observe(document.body, { childList: true, subtree: true })
  }
})
